// Share messages for a gig. Two audiences, two messages:
//  - familyShareMessage: public link, where and when only (no fee, dress code or call time)
//  - depShareMessage: deputy link, everything needed to play the gig
import { format, parseISO } from "date-fns";
import { openExternalLink } from "@/lib/utils";

const dayLabel = (gig) => {
  try {
    return gig?.date ? format(parseISO(gig.date), "EEEE d MMMM yyyy") : "";
  } catch {
    return "";
  }
};

export const familyShareMessage = (gig, publicUrl) =>
  [
    `${gig.artist_name}, ${dayLabel(gig)}`,
    gig.venue_name,
    gig.venue_address,
    gig.start_time ? `Starts ${gig.start_time}` : null,
    gig.ticket_link ? `Tickets: ${gig.ticket_link}` : null,
    `Full details (kept up to date): ${publicUrl}`,
  ].filter(Boolean).join("\n");

export const depShareMessage = (gig, depUrl) =>
  `Dep needed: ${gig.artist_name} at ${gig.venue_name}, ${dayLabel(gig)}. Everything you need to play is here: ${depUrl}`;

// Creates (or reuses) the deputy link for a gig and returns its full URL.
// The API client is passed in so this module doesn't import App.js.
export const createDepLink = async (client, gigId) => {
  const res = await client.put(`/gigs/${gigId}/dep-share`);
  return `${window.location.origin}/dep/gig/${res.data.dep_share_token}`;
};

// Opens WhatsApp or the device's text app with the message filled in.
export const openShareChannel = (platform, message) => {
  const encoded = encodeURIComponent(message);
  if (platform === "whatsapp") {
    openExternalLink(`https://wa.me/?text=${encoded}`);
  } else {
    window.location.href = `sms:?body=${encoded}`;
  }
};

// Public family link (the /og variant is what previews correctly in chat apps).
export const publicShareUrl = (apiBase, token) => `${apiBase}/share/gig/${token}/og`;
